import { DataTable } from "../DataTable/DataTable";
import { useDocumentTitle } from "usehooks-ts";
import { DataTableContextProvider } from "../DataTable/DataTableContext";
import { GLOBAL_ASSOCIATIONS_QUERY_KEY } from "./constants";

/* NOTE: The DataTable in this component can't use any of the fanciness that other tables have (sorting, filtering, etc) because I don't use an aggregation on the backend to get the data. The data itself is a single document, not a collection. I'm cheating a bit to get the same look (and download functionality) as the other tables. */

export const GlobalAssociations: React.FC = () => {
  useDocumentTitle("Global Associations");

  return (
    <div className="flex flex-col gap-6">
      <p className="text-dm-charcoal-500">
        <b>Global Associations:</b> When a skill title contains a global
        association, all corresponding associations are added to the skill as
        searchable tags.
      </p>
      <DataTableContextProvider
        source="/manager_new/module/global_associations/list"
        fetchOnLoad
        queryKey={GLOBAL_ASSOCIATIONS_QUERY_KEY}
        defaults={{ sortBy: [{ id: "globalAssociations", desc: false }] }}
      >
        <DataTable />
      </DataTableContextProvider>
    </div>
  );
};
